/*
Akhila 11/19/2022 2700271704 Created new Component
Sohel 11/21/2022 2700271704 prepopulate field Table values
Sohel 11/22/2022 2700271704 reset client Row data
Sohel 12/04/2022 2700271704 rename column name
Prakash 12/06/2022 2700271704 Added useStates for conditional rendering popup width.
Rajesh 12/15/2022 2700271704 added role access
Ashraf 12/15/2022 2700271704 fixed role access
kavyareddy 12/26/2022 2700271704 Renamed formulaCode to Data calaculation
Raghu 02/23/2023 2700271704 fixed new Ui changes
Ravi 04/19/2023 2700271704 Rename Add Field to Account Update
Ravi 04/20/2023 2700271704 Rename Add Field to Account Update Add Field
Ravi 05/31/2023 2700271704 changed delete popup message
Akhila 05/31/2023 2700271704 unsaved changes bug fixed
*/
import React, {createRef, useEffect, useState} from 'react';
// import MaterialTable from "material-table";
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {tablePageRows, defaultRows} from '../../../../../constants/ReusableTablePagination';
import {Button} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DialogBox from '../../../../../components/DialogBox';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import AddClientAccountForm from './AddClientAccountForm';
import {useSelector} from 'react-redux';
export default function AddClientAccountTable({
  clientFormData,
  setClientFormData,
  setDeletedClientData,
  deletedClientData,
  getValues,
  handleDirty,
}) {
  const [clientForm, setClientForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [clientRowData, setClientRowData] = useState({});
  const [deleteData, setDeleteData] = useState({});
  const [isDelete, setIsDelete] = useState(false);
  const [searchEventTactics, setSearchEventTactics] = useState(false);
  const [openFormulaCode, setOpenFormulaCode] = useState(false);

  const handleClientFormClose = () => {
    setClientForm(false);
    setIsEdit(false);
  };
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);

  const handleCloseDialog = () => {
    setIsDelete(false);
  };

  const handleConfirmDelete = () =>
    new Promise((resolve, reject) => {
      setTimeout(() => {
        const dataDelete = [...clientFormData];
        const index = deleteData.tableData.id;
        dataDelete.splice(index, 1);
        setClientFormData([...dataDelete]);
        deletedClientData?.length > 0 ?
          setDeletedClientData([...deletedClientData, deleteData?.triggerAccountUpdateFieldsId]) :
          deleteData?.triggerAccountUpdateFieldsId ?
            setDeletedClientData([deleteData?.triggerAccountUpdateFieldsId]) :
            setDeletedClientData([]);
        resolve();
        setIsDelete(false);
      }, 1000);
      handleDirty(true);
    });

  const columns = [
    {
      title: 'Repository Name',
      field: 'fieldCode',
    },
    {
      title: 'Field Name',
      field: 'description',
    },
    {
      title: 'Value',
      field: 'value',
      render: (rowData) => (rowData?.value ? rowData?.value : '-'),
    },
    {
      title: 'Data calculation ',
      field: 'formulaCode',
      render: (rowData) => (rowData?.formulaCode ? rowData?.formulaCode : '-'),
    },
  ];

  const tableRef = createRef();
  const {roleData} = useSelector(({role}) => role);
  const disable = roleData?.window?.['Account Update']?.['AUG'];
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title={'Delete Field'}
        value={`Are you sure you want to delete the ${deleteData?.description} Field?`}
        handleSubmit={handleConfirmDelete}
      />
      <DialogBox
        open={clientForm || isEdit}
        dialogClose={handleClientFormClose}
        title={clientForm ? 'Account Update-Add Field' : isEdit ? 'Account Update-Edit Field' : ''}
        maxWidth={openFormulaCode || searchEventTactics ? 'xl' : 'md'}
        hideFooter={true}
      >
        <AddClientAccountForm
          setClientFormData={setClientFormData}
          clientFormData={clientFormData}
          setClientForm={setClientForm}
          clientRowData={clientRowData}
          setIsEdit={setIsEdit}
          isEdit={isEdit}
          searchEventTactics={searchEventTactics}
          setSearchEventTactics={setSearchEventTactics}
          openFormulaCode={openFormulaCode}
          setOpenFormulaCode={setOpenFormulaCode}
          getValues={getValues}
          handleDirty={handleDirty}
        />
      </DialogBox>
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-actions-icon custom-toolbar-icons trigger-table new-standard-textfields">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={clientFormData || []}
            tableRef={tableRef}
            textAlign="left"
            options={{
              search: false,
              pageSize: defaultRows,
              pageSizeOptions: tablePageRows,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
            }}
            actions={[
              {
                icon: () => (
                  <>
                    <EditOutlinedIcon />
                  </>
                ),
                tooltip: 'Edit',
                disabled: getValues()?.groupCode && !disable?.edit,
                onClick: (event, rowData) => {
                  setIsEdit(true);
                  setClientRowData(rowData);
                },
              },
              {
                icon: () => (
                  <div>
                    <Button
                      variant="outlined"
                      className="search-btn"
                      disabled={getValues()?.groupCode && !disable?.edit}
                      onClick={() => {
                        setClientForm(true);
                      }}
                    >
                      <AddIcon /> Account Update-Add Field
                    </Button>
                  </div>
                ),
                isFreeAction: true,
                onClick: () => {
                  setClientForm(true);
                  setClientRowData({});
                },
              },
              (rowData) => {
                return {
                  icon: () => (
                    <>
                      <DeleteOutlineOutlinedIcon />
                    </>
                  ),
                  tooltip: 'Delete',
                  disabled: getValues()?.groupCode && !disable?.delete,
                  onClick: () => {
                    setIsDelete(true);
                    setDeleteData(rowData);
                  },
                };
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <div className="mt-2"></div>
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                      }}
                    />
                  </div>
                </div>
              ),
            }}
          />
        </div>
      </Grid>
    </>
  );
}
